export const sectionNav = [
  { id: 'recent', label: '最新近况' },
  { id: 'films', label: '新片速览' },
  { id: 'filmography', label: '作品年表' },
  { id: 'photos', label: '写真合集' },
  { id: 'events', label: '活动日历' },
  { id: 'news', label: '资讯消息' },
  { id: 'guide', label: '主题解读' },
  { id: 'faq', label: '常见问题' },
];